import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "actualite-area gray-bg actualite-3 section-padding pt-100" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row mt-30 actualite-item-wrap" }
const _hoisted_4 = { class: "article-stack" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "stack-loader"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "spinner" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "Chargement…", -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = ["src", "onLoad"]
const _hoisted_11 = {
  key: 1,
  class: "stack-placeholder"
}
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  key: 1,
  class: "no-image"
}
const _hoisted_14 = { class: "article-titles" }
const _hoisted_15 = { class: "mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.articles, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-md-4 mb-5",
            key: item.id
          }, [
            _createElementVNode("div", _hoisted_4, [
              (item.medias && item.medias.length)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "stack-gallery",
                    onClick: ($event: any) => (_ctx.goToDetails(item.id))
                  }, [
                    (_ctx.loadingImages[item.id])
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_9))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleMedias(item.medias), (media, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: media.id,
                        class: _normalizeClass(["stack-image", 'layer-' + (index + 1)])
                      }, [
                        (!_ctx.isVideo(media.description))
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: _ctx.getUrlApiForFiles(media.description),
                              alt: "aperçu",
                              loading: "lazy",
                              onLoad: ($event: any) => (_ctx.onImageLoaded(item.id, _ctx.visibleMedias(item.medias).length))
                            }, null, 40, _hoisted_10))
                          : _createCommentVNode("", true)
                      ], 2))
                    }), 128))
                  ], 8, _hoisted_5))
                : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    (item.urlImage)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _ctx.getUrlApiForFiles(item.urlImage),
                          alt: ""
                        }, null, 8, _hoisted_12))
                      : (_openBlock(), _createElementBlock("div", _hoisted_13, "Aucune image"))
                  ])),
              _createElementVNode("div", _hoisted_14, _toDisplayString(item.titre), 1)
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_PaginationComponent, {
          page: _ctx.page,
          totalPages: _ctx.totalPages,
          totalElements: _ctx.totalElements,
          limit: _ctx.limit,
          onPaginate: _ctx.handlePaginate
        }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
      ])
    ])
  ]))
}